<mprd-telephony-level-two-skeleton *ngIf="!selectedProduct"></mprd-telephony-level-two-skeleton>
<section
  *ngIf="selectedProduct"
  class="rs-content-wrapper rs-header-has-level2"
  id="telephonyLevelTwo"
>
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-tit1-sp rs-txt-c2 rs-has-subtit">
            {{ selectedProduct?.productDescription }}
          </h1>
          <p
            class="rs-txt-s5 rs-txt-c2 small-only-text-center"
            x-ms-format-detection="none"
            data-cy="telephoneNumber"
          >
            <mprd-access-number-formatter
              [accessNumber]="selectedProduct?.accessNumber"
              [plc]="selectedProduct?.plc"
            ></mprd-access-number-formatter>
          </p>

          <div class="panel rs-panel-big clearfix">
            <mprd-usage-header
              [product]="selectedProduct"
              [remainingDaysLabel]="remainingDaysLabel"
              *ngIf="remainingDaysLabel"
            ></mprd-usage-header>

            <div class="row">
              <div class="columns small-12 medium-6">
                <px-usage-level-2-container
                  [product]="usageProduct"
                  (usageRemainingDays)="usageInitializedWith($event)"
                >
                </px-usage-level-2-container>
              </div>
              <div class="columns small-12 medium-6" data-masonry-item="">
                <px-bipt
                  *ngIf="selectedProduct && isRes"
                  [plc]="selectedProduct.plc"
                  [serviceId]="selectedProduct.accessNumber"
                  [analyticsLocation]="'fixed telephony options'"
                ></px-bipt>
              </div>
            </div>

            <div class="rs-me"></div>

            <h2 class="rs-tit3">{{ 'telephony.options' | translate }}</h2>
            <div class="panel rs-bg-grey1 clearfix" data-cy="telephonyOptions">
              <p *ngIf="'telephony.options.no.longer.shown' | translate">
                {{ 'telephony.options.no.longer.shown' | translate }}
              </p>
              <ng-container *ngIf="'telephony.options.call.setup.phone' | translate: true">
                <p [innerHTML]="'telephony.options.call.setup.phone' | translate: true"></p>
              </ng-container>
              <p *ngIf="'telephony.options.manage.title' | translate">
                {{ 'telephony.options.manage.title' | translate }}
              </p>
              <ng-container *ngIf="'telephony.options.list.options.managed' | translate: true">
                <span
                  [innerHTML]="'telephony.options.list.options.managed' | translate: true"
                ></span>
              </ng-container>
              <ng-container *ngIf="'telephony.options.help.link' | translate: true">
                <p [innerHTML]="'telephony.options.help.link' | translate: true"></p>
              </ng-container>
            </div>
          </div>

          <div class="rs-mh-s2 rs-mh-m6"></div>

          <div class="rs-le2"></div>
        </div>
      </div>
      <!-- START - FAQ -->
      <div [innerHtml]="faqHtml"></div>
      <!-- END - FAQ -->
    </section>
  </main>
</section>
